import * as PIXI from "pixi.js";

export class PredefinedPIXIAnchorPoint {
    public static readonly DEFAULT: any = new PIXI.Point(0, 0);
    public static readonly LEFT_ALIGN: any = new PIXI.Point(0, 0.5);
    public static readonly RIGHT_ALIGN: any = new PIXI.Point(1, 0.5);
    public static readonly CENTER: any = new PIXI.Point(0.5, 0.5);
}



// WEBPACK FOOTER //
// ./src/PredefinedPIXIAnchorPoint.ts